import { getCount, getLoadData, getMyLoadsFilteredCount } from "../../../selectors/Myload/selector";
import {
  getLoading,
  getUserMasterData,
  getNetworkStatus
} from "../../../selectors/selector";
import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import { createStructuredSelector } from "reselect";
import { getCarrierTenderedLoad, getDriverList } from "../../../selectors/carrierAssign/selector";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { fetchShipments } from "../../../actions/carrierAssign/action";
import { isEntitled } from "../../../utils/common";
import { MyLoad } from "../../../models/myLoad/myLoad";
import { MyLoadsError } from "../../../components/MyLoadsError/MyLoadsError";
import i18n from "i18n";
import { TenderAction } from "../../../models/myLoad/tenderAction.model";
import { CarrierTenderedPage } from "../../pages/CarrierTendered";
import { isElevatedLeasedOwenerOprRole } from "app/utils/roleUtil/RoleUtil";
import { FetchFromMyLoadConfig } from "../../../utils/MyLoads.util";

const CarrierTenderedContainer: React.FC<any> = (props: any) => {
  useEffect(() => {
    setScreenName("screen_carrierTendered");
    logEvent(EVENT.SV_VIEW_CARRIER_TENDERED, {
      screen: SCREEN.MYLOADS_CARRIER_TENDERED,
      carrierId:
        (props && props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.carrierId) || "",
    });
  }, []);
  const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");
  const userPrincipalName: string =
    (props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member && props.userDetails.memberDetailsResponse.member.upn) || "";
  const [pageIndex, setPageIndex] = useState<number>(0);
  const getPaginatedLoads = (page?: number,SelectedFilterOption?: any) => {
    const isDriver = !isEntitled("myLoad", "carrierAssigned");
    const _model: MyLoad = new MyLoad();
    if (isDriver || isElevatedLeasedOwenerOprRole()) {
      _model.driverId = userPrincipalName;
      _model.filter = {
        driverAssigned: true,
      };
    } else {
      _model.filter = {
        driverAssigned: true,
      };
    }
    if (page === 0 || page) setPageIndex(page)
    _model.filter = {
      carrierAssigned: isEntitled("myLoad", "carrierAssigned"),
      driverAssigned: true,
      carrierTendered: isEntitled("myLoad", "carrierTendered"),
      inTransit: true,
      deliveredNeedsPaperWork: true,
      deliveredWithPaperWork: true,
    };
    _model.pagination = {
      pageSize: myLoadsMaxPageSize,
      pageIndex: (page === 0 || page) ? page : pageIndex,
    }
    // if(SelectedFilterOption?.partyId === "Unknown"){
    //   _model.pagination["myLoadPageFilter"] = [{filterName:"driverId",filterValue: ""}]
    // } else if(SelectedFilterOption?.partyId === "All_Drivers"){
    //   _model.pagination["myLoadPageFilter"] = (isDriver || isElevatedLeasedOwenerOprRole()) ? null :  [{filterName:"driverId",filterValue: null}]
    // } else if(SelectedFilterOption?.partyId && (SelectedFilterOption?.partyId !== "All_Drivers" || SelectedFilterOption?.partyId !== "Unknown")){
    //   _model.pagination["myLoadPageFilter"] = [{filterName:"driverId",filterValue: SelectedFilterOption?.partyId}]
    // }
    props.fetchMyloads(_model.getCarrierTenderedShipments());
  };
  useEffect(() => {
    if(!props?.location?.state?.isGlobalSearch){
      getPaginatedLoads()
    }
  }, [props?.location?.state?.isGlobalSearch]);

  const { carrierTenderedCount = 0 } = props.count;
  return (
    (carrierTenderedCount !== 0) ? <CarrierTenderedPage {...props}
      paginatedLoads={(page: number) => getPaginatedLoads(page)}
      page={pageIndex} /> :
      <MyLoadsError
        data-test="MyLoadsError"
        constantText={i18n.t('searchResultsErrorText')}
        history={props.history}
        redirectTo={"/app/search"}
        constantButton={i18n.t('Reset Search')}
      />
  );
};
const mapStateToProps = createStructuredSelector({
  loading: getLoading(),
  loads: getCarrierTenderedLoad(),
  userDetails: getUserMasterData(),
  isNetworkAvailable: getNetworkStatus(),
  driverList: getDriverList(),
  loadData: getLoadData(),
  count: getCount(),
  getMyLoadsFilteredCount: getMyLoadsFilteredCount()
});
export const mapDispatchToProps = (dispatch: Function) => ({
  fetchMyloads: (details: any) => dispatch(fetchShipments(details, false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarrierTenderedContainer);
